export default objects => {
	objects.forEach(obj => obj.style.display = null);
	return objects;
}
